import { ValidatorRule, Validator } from './validation.interfaces';

export abstract class ValidatorBase implements Validator {
  private rulesMap = new Map<string, ValidatorRule>();

  private _invalidRules: ValidatorRule[] = [];
  get invalidRules(): ValidatorRule[] {
    return this._invalidRules;
  }

  private _validRules: ValidatorRule[] = [];
  get validRules(): ValidatorRule[] {
    return this._validRules;
  }

  private _isValid: boolean;
  get isValid(): boolean {
    return this._isValid;
  }

  get rules(): ValidatorRule[] {
    return [...this.rulesMap.values()];
  }

  constructor() {}

  protected addRule(rule: ValidatorRule, key: string): void {
    rule.onStateChanged(rule => this.updateResultSets(rule));
    this.rulesMap.set(key, rule);
    this.updateResultSets(rule);
  }

  public getRule(key: string) {
    return this.rulesMap.get(key);
  }

  validate(key?: string) {
    let validationRules: ValidatorRule[];

    // Validate just the key, or validate all rules
    if (key) {
      let rule = this.getRule(key);
      validationRules = [rule];
    } else {
      validationRules = [...this.rulesMap.values()];
    }

    for (let rule of validationRules) {
      rule.validate();
    }
  }

  protected updateResultSets(rule: ValidatorRule) {
    // Remove from invalid as needed
    let indexInInvalid = this.invalidRules.indexOf(rule);
    if (rule.isValid && indexInInvalid != -1) {
      this.invalidRules.splice(indexInInvalid, 1);
    }

    // Remove from valid as needed
    let indexInValid = this.validRules.indexOf(rule);
    if (!rule.isValid && indexInValid != -1) {
      this.validRules.splice(indexInValid, 1);
    }

    // Add to invalid as needed
    if (!rule.isValid && indexInInvalid == -1) {
      this.invalidRules.push(rule);
    }

    // Add to valid as needed
    if (rule.isValid && indexInInvalid == -1) {
      this.validRules.push(rule);
    }

    this.updateIsValidState();
  }

  private updateIsValidState() {
    let isValid = this._invalidRules.length == 0;
    this.setIsValidState(isValid);
  }

  private stateChangedCallbacks: ((validator: Validator) => void)[] = [];
  onStateChanged(callback: (validator: Validator) => void): () => void {
    this.stateChangedCallbacks.push(callback);

    let detachHandler = () => {
      let callbackIndex = this.stateChangedCallbacks.indexOf(callback);
      if (callbackIndex == -1) return;
      this.stateChangedCallbacks.splice(callbackIndex, 1);
    };
    return detachHandler;
  }

  private setIsValidState(isValidState: boolean) {
    if (this._isValid == isValidState) return;
    this._isValid = isValidState;

    // Raise the callbacks
    for (let stateChangeCallback of this.stateChangedCallbacks) {
      stateChangeCallback(this);
    }
  }
}
